module.exports = __webpack_public_path__ + "static/img/bg_item_3.ef9915e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/bg_item_3.png
// module id = ijG7
// module chunks = 1